export enum QuestionnaireStatus {
    Draft = "draft",
    Published = "published"
 };
